export const decodeBase64 = (
  encodedString: string | undefined | null
): string => {
  if (!encodedString) return '';
  // Convert Base-64 back to a UTF-8 string.
  return Buffer.from(encodedString, 'base64').toString('utf8');
};
